module.exports = __webpack_public_path__ + "img/circlebg.1ec47698.svg";